import React from 'react';
import CallForProposalForm from './Form';

const CallForProposalFormEdit = () => {
  return (
    <div className="block block-editor-cfpForm cfp-form-block">
      <div className="cfp-form-surface">
        <CallForProposalForm readOnly />
      </div>
    </div>
  );
};

export default CallForProposalFormEdit;
